import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { FormattedMessage, injectIntl, intlShape } from 'react-intl'

import { CardElement } from 'react-stripe-elements'

class CreditCardPayment extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      number: '',
      name: '',
      expiry: '',
      cvc: '',
      focused: '',
      errors: {},
    }
  }

  handleInputFocus(event) {
    const { name } = event.target

    this.setState({
      focused: name,
    })
  }

  handleCardChange(event) {
    const { onChange } = this.props
    const { name, value } = event.target

    if (name === 'magic-no-complete') {
      this.setState({
        name: value,
      })
    } else {
      this.setState({
        [name]: value,
      })
    }

    onChange(this.state)
  }

  render() {
    const { errors } = this.props
    // const { intl, errors } = this.props
    // const { formatMessage } = intl
    // const { number, name, expiry, cvc, focused } = this.state;

    return (
      <div className="space--bottom-1">
        <h2 className="beta space--bottom-1">
          <FormattedMessage id="app.cart.step.infos.card-data" />
        </h2>
        <CardElement
          style={{
            base: {
              color: '#5a3d6a',
              fontFamily: '',
              fontSize: '15px',
              fontSmoothing: '',
              fontWeight: 'normal',
              lineHeight: '22px',
              letterSpacing: 'normal',
            },
            invalid: {

            },
          }}
        />
        {
          errors.card &&
        <div className="form__card-error">{errors.card}</div>
        }
        <div className="form__field space--top-1">
          <label className="form__label">
            <FormattedMessage id="app.cart.step.infos.fields.name" />
          </label>
          <input
            autoComplete="new-password"
            name="magic-no-complete"
            onKeyUp={this.handleCardChange.bind(this)}
            onFocus={this.handleInputFocus.bind(this)}
            type="text"
            required
          />
        </div>
      </div>
    )
  }
}

CreditCardPayment.propTypes = {
  intl: intlShape.isRequired,
  onChange: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired,
}

function mapStateToProps() {
  return {}
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({}, dispatch)
}

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(CreditCardPayment))
